/**
 * Banner copy override for the QA offering pages reviewed by the QA team.
 *
 * On these pages the "Let's talk Quality Assurance" banner shows the reviewed
 * sentence and its button links to the contact page instead of opening the form
 * dialog. The override is English-only on purpose: Spanish and Chinese keep
 * their existing localized banner text so language parity is preserved.
 */
export const QA_REVIEWED_BANNER_KEYS = new Set<string>([
  "outsourced-qa",
  "audits-and-remediation",
  "qualified-person-qp-responsible-person-rp",
  "annual-product-review-apr-product-quality-review-pqr",
]);

export const QA_REVIEWED_BANNER_COPY =
  "Whether you are preparing for an inspection, need additional QA capacity or want to strengthen your quality system, our QA experts are ready to help.";

/** Returns the reviewed banner sentence for reviewed English offerings, otherwise null. */
export function getReviewedQABannerCopy(contentKey: string, lang: string): string | null {
  if (lang !== "en") return null;
  return QA_REVIEWED_BANNER_KEYS.has(contentKey) ? QA_REVIEWED_BANNER_COPY : null;
}
